module.exports = __webpack_public_path__ + "assets/img/blockchain_preview_24px.dd0c568b.svg";